import { BaseEntity } from './base.entity';

export class CardHistoryEntity implements BaseEntity {
  public key!: string;
  public createdAt: Date = new Date();
  public updatedAt: Date = new Date();
  public cardKey!: string;
  public description!: string;
  public action!: string;
  public newValue!: string;
  public oldValue!: string;
  public user!: string;
  public changedDate!: number;
  public fieldName!: string;
  public assignedToUserKey: string = '';
  public assignedToRole: string = '';
}
